// Notification messages can carry a post's rich text ("<p>text</p>"), at
// times HTML-escaped one or more layers deep ("&lt;p&gt;text&lt;/p&gt;").
// Return the plain text: DOMParser builds an inert document (no scripts run,
// no images load), and decoding repeats while the text is still markup.
const MAX_LAYERS = 5;

export function htmlToText(value: unknown): string {
  if (typeof value !== 'string' || !value) return '';
  let text = value;
  for (let i = 0; i < MAX_LAYERS; i++) {
    const decoded = new DOMParser().parseFromString(text, 'text/html').body.textContent || '';
    const done = decoded === text || !/<\/?[a-z][^>]*>|&[a-z#0-9]+;/i.test(decoded);
    text = decoded;
    if (done) break;
  }
  return text.replace(/\s+/g, ' ').trim();
}
